import { type EntityId } from '@terros/common'
import { type QueryKey } from '@tanstack/react-query'

export const entitlementsKey = (entityId?: EntityId): QueryKey => {
  if (!entityId) return ['entitlements']
  return ['entitlements', entityId]
}
